import React, {FunctionComponent} from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

const IconEmptyCalendar: FunctionComponent<IconProps> = ({
  className, height, title,
}) =>
  (
    <Icon className={className} height={height} title={title}>
      M7.41669 1.5C7.41669 1.08579 7.0809 0.75 6.66669 0.75C6.25247 0.75 5.91669 1.08579 5.91669 1.5V2.25H5C3.48122 2.25
      2.25 3.48122 2.25 5V15C2.25 16.5188 3.48122 17.75 5 17.75H15C16.5188 17.75 17.75 16.5188 17.75 15V5C17.75 3.48122
      16.5188 2.25 15 2.25H14.0833V1.5C14.0833 1.08579 13.7475 0.75 13.3333 0.75C12.9191 0.75 12.5833 1.08579 12.5833
      1.5V2.25H7.41669V1.5ZM5.91669 3.75V4.83333C5.91669 5.24755 6.25247 5.58333 6.66669 5.58333C7.0809 5.58333 7.41669
      5.24755 7.41669 4.83333V3.75H12.5833V4.83333C12.5833 5.24755 12.9191 5.58333 13.3333 5.58333C13.7475 5.58333
      14.0833 5.24755 14.0833 4.83333V3.75H15C15.6904 3.75 16.25 4.30964 16.25 5V7.41663H3.75V5C3.75 4.30964 4.30964
      3.75 5 3.75H5.91669ZM3.75 8.91663V15C3.75 15.6904 4.30964 16.25 5 16.25H15C15.6904 16.25 16.25 15.6904 16.25
      15V8.91663H3.75Z
    </Icon>
  );

export default IconEmptyCalendar;
